'use client';

import React, { useMemo } from 'react';
import { Box, Text, VStack } from '@skin-seoul/design-system';
import { SKIN_CONCERN_DESCRIPTION } from '@skin-seoul/service';
import ModalContainer from '../../../components/ModalContainer';
interface SkinConcernModalProps {
  isOpen: boolean;
  onClose: () => void;
  items: Array<{
    name: string;
    slug: string;
  }>;
}
interface SkinConcernItem {
  title: string;
  descriptions: string[];
}
const capitalizeWords = (text: string): string => {
  return text.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};
const SkinConcernModal = ({
  isOpen,
  onClose,
  items
}: SkinConcernModalProps) => {
  const skinConcerns: SkinConcernItem[] = useMemo(() => items.map(item => {
    const capitalizedName = capitalizeWords(item.name);
    const description = SKIN_CONCERN_DESCRIPTION[capitalizedName];
    if (!description) {
      return null;
    }
    return {
      title: capitalizedName,
      descriptions: description.descriptions
    };
  }).filter((item): item is SkinConcernItem => item !== null), [items]);
  return <ModalContainer isOpen={isOpen} onClose={onClose} title="Skin Concern" data-sentry-element="ModalContainer" data-sentry-component="SkinConcernModal" data-sentry-source-file="SkinConcernModal.tsx">
      <VStack gap={6} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="SkinConcernModal.tsx">
        {/* Description Box */}
        <Box backgroundColor="primary.50" borderRadius={8} padding={4} width="100%" data-sentry-element="Box" data-sentry-source-file="SkinConcernModal.tsx">
          <Text textStyle={{
          base: 'label.small',
          tablet: 'label.medium'
        }} color="neutral.800" data-sentry-element="Text" data-sentry-source-file="SkinConcernModal.tsx">
            Your skin type affects how products work on you.Check the guide below to figure out which type or condition
            best describes your skin.
          </Text>
        </Box>

        {/* Skin Concerns */}
        <VStack gap={6} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="SkinConcernModal.tsx">
          {skinConcerns.map((concern, index) => <VStack key={index} gap={4} width="100%" alignItems="flex-start">
              <Text textStyle="label.large" color="neutral.800" fontWeight="medium">
                {concern.title}
              </Text>
              <Box as="ul" listStyleType="disc" paddingLeft={6} margin={0}>
                {concern.descriptions.map((description, descIndex) => <Box as="li" key={descIndex} marginBottom={2}>
                    <Text textStyle={{
                base: 'paragraph.small',
                tablet: 'paragraph.medium'
              }} color="neutral.600">
                      {description}
                    </Text>
                  </Box>)}
              </Box>
            </VStack>)}
        </VStack>
      </VStack>
    </ModalContainer>;
};
export default SkinConcernModal;